import styles from "./empty-footer.module.scss";

// Intended for use in pages where a footer is not needed
// but the page can benefit from added padding at the bottom

const EmptyFooter = () => {
  return (
    <footer className={styles.emptyFooter}>
      <div className={styles.footerContent}></div>
    </footer>
  );
};

export default EmptyFooter;
